// extracted by mini-css-extract-plugin
module.exports = {"camp-D":"D_camp-D__jcgFv"};